import React from "react";
import MenuMobile from "./Menu/MenuMobile";
import MenuDesktop from "./Menu/MenuDesktop";

const Wrapper = ({ children }) => {
  const responsiveLayoutSelector = () => {
    let mobile = window.matchMedia("(max-width: 768px)");
    let desktop = window.matchMedia("(min-width: 768px)");

    if (mobile.matches) {
      return <MenuMobile children={children}></MenuMobile>;
    }
    if (desktop.matches) {
      return <MenuDesktop children={children}></MenuDesktop>;
    }
  };

  return responsiveLayoutSelector();
};

export default Wrapper;
